import React from 'react';
import { withRouter } from 'found';
import { commitMutation, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import styles from '../Document.scss';
import Header from './Header';
import MobileSidebar from 'react-sidebar';
import Sidebar from '../../App/SidebarComponent';
import NotFound from '../../App/404';
import { Loader } from '../../Elements';
import {
  Button,
  Container,
  Divider,
  Grid,
  Icon,
  Rail,
  Segment
} from 'semantic-ui-react';
import Schedule from './Schedule';
import LineItems from './LineItems';
import Library from './Library';
import Brand from './Brand';
import Logo from './Logo';
import Recipient from './Recipient';
import Actions from './Actions';
import Payments from './Payments';
import PaymentPlan from './PaymentPlan';
import Pay from './Pay';
import Refunds from './Refunds';
import { RootConsumer } from '../../RootComponent';
import moment from 'moment-timezone';

const Invoice = class Invoice extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    params: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.canEdit = this.canEdit.bind(this);
    this.hasRecipient = this.hasRecipient.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.closeSetupPaymentMethods = this.closeSetupPaymentMethods.bind(this);
    this.openSetupPaymentMethods = this.openSetupPaymentMethods.bind(this);
    this.openAddPayment = this.openAddPayment.bind(this);
    this.closeAddPayment = this.closeAddPayment.bind(this);

    this.state = {
      addPaymentOpen: false,
      error: !this.props.node,
      sidebarOpen: false,
      setupPaymentMethodsOpen: false
    };
  }

  componentWillMount() {
    if (!this.props.node && this.props.location.query.share_token) {
      this.addInvoiceToSession();
    }
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  addInvoiceToSession() {
    this.setState({ error: false });
    const onCompleted = () => {
      this.props.relay.refetch(fragmentVariables => fragmentVariables, null);
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation InvoiceComponent_addInvoiceToSessionMutation(
        $input: AddInvoiceToSessionInput!
      ) {
        addInvoiceToSession(input: $input) {
          invoice {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.location.query;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  toggleSidebar(ev) {
    ev.preventDefault();
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }

  closeSetupPaymentMethods() {
    this.setState({ setupPaymentMethodsOpen: false });
  }

  openSetupPaymentMethods() {
    this.setState({ setupPaymentMethodsOpen: true });
  }

  closeAddPayment() {
    this.setState({ addPaymentOpen: false });
  }

  openAddPayment() {
    this.setState({ addPaymentOpen: true });
  }

  canEdit() {
    return this.props.node.can_edit && this.props.params.action === 'edit';
  }

  hasRecipient() {
    const { node } = this.props;
    return (node.recipient_first_name ||
      node.recipient_last_name ||
      node.recipient_company_name ||
      node.recipient_phone ||
      node.recipient_email ||
      node.recipient_address) && true;
  }

  render() {
    const CheckIcon = (
      <Icon name='check circle' color='green' style={{ marginLeft: '0.5em' }} />
    );

    const ActionsMenu = (
      <RootConsumer>
        {({ window }) =>
          <Actions
            node={this.props.node}
            addPayment={this.openAddPayment}
            openSetupPaymentMethods={this.openSetupPaymentMethods}
            params={this.props.params}
            relay={this.props.relay}
            router={this.props.router}
            viewer={this.props.viewer}
            windowDimensions={window}
          />}
      </RootConsumer>
    );

    const paidInFull = this.props.node
      ? this.props.node.total_cents <= this.props.node.total_paid_cents
      : null;

    const PayButtonDesktop = (
      <Button
        content='Pay Invoice'
        size='large'
        className={styles.actionButton}
        style={paidInFull ? { display: 'none' } : {}}
        onClick={this.openSignModal}
      />
    );

    const PayButtonMobile = (
      <Button
        content='Pay Invoice'
        fluid
        primary
        size='big'
        style={paidInFull ? { display: 'none' } : {}}
        onClick={this.openSignModal}
      />
    );

    return (
      <RootConsumer>
        {({ isComputer, isLargeScreen, isMobile, window }) =>
          <div>
            {this.props.node &&
              <MobileSidebar
                sidebar={
                  <Sidebar
                    setSidebarOpenState={this.onSetSidebarOpen}
                    router={this.props.router}
                    viewer={this.props.viewer}
                  />
                }
                sidebarClassName={styles.sidebar}
                open={this.state.sidebarOpen}
                onSetOpen={this.onSetSidebarOpen}
                touch={false}
                contentClassName={styles.mobileSidebarContent}
                rootClassName={styles.mobileSidebarRoot}
              >
                <Header
                  addPayment={this.openAddPayment}
                  toggleSidebar={this.toggleSidebar}
                  sidebarOpen={this.state.sidebarOpen}
                  document={this.props.node}
                  relay={this.props.relay}
                  router={this.props.router}
                  params={this.props.params}
                  viewer={this.props.viewer}
                  windowDimensions={window}
                />
                <Container
                  className={[
                    styles.container,
                    this.props.params.action !== 'edit' ? styles.documentOffset : ''
                  ].join(' ')}
                >
                  {!isLargeScreen && isComputer &&
                    <Grid>
                      <Grid.Row
                        columns='equal'
                        className={styles.actionsMenuTablet}
                      >
                        <Grid.Column>
                          {ActionsMenu}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>}
                  <Segment className={styles.segment}>
                    {isLargeScreen &&
                      <Rail
                        position='right'
                        close
                        className={styles.actionsMenuDesktop}
                      >
                        {ActionsMenu}
                      </Rail>}
                    <Grid>
                      <Grid.Row
                        columns='equal'
                        style={{ paddingTop: 0, paddingBottom: '2em' }}
                      >
                        <Grid.Column className={styles.invoiceNumber}>
                          Invoice #{this.props.node.number}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <Grid padded relaxed stackable>
                      <Grid.Row
                        columns='equal'
                        verticalAlign='bottom'
                        style={{ paddingBottom: 0 }}
                      >
                        <Grid.Column>
                          <Logo
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                        <Grid.Column only='tablet computer' textAlign='right'>
                          {(this.hasRecipient() || this.canEdit()) &&
                            <h3 className={styles.to}>Billed To:</h3>}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns='equal'>
                        <Grid.Column>
                          <Brand
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                        <Grid.Column only='mobile' style={{ paddingBottom: 0 }}>
                          {(this.hasRecipient() || this.canEdit()) &&
                            <h3 className={styles.to}>Billed To:</h3>}
                        </Grid.Column>
                        <Grid.Column textAlign={isMobile ? 'left' : 'right'}>
                          <Recipient
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {(this.canEdit() ||
                        this.props.node.invoice_event_segments.edges.length > 0) &&
                        <Grid.Row className={styles.section}>
                          <Grid.Column width={16}>
                            <Divider horizontal className={styles.heading}>
                              Schedule
                            </Divider>
                          </Grid.Column>
                        </Grid.Row>}
                      <Grid.Row columns='equal'>
                        <Grid.Column>
                          <Schedule
                            invoiceEventSegments={
                              this.props.node.invoice_event_segments.edges
                            }
                            viewer={this.props.viewer}
                            relay={this.props.relay}
                            readOnly={!this.canEdit()}
                            node={this.props.node}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {(this.canEdit() ||
                        this.props.node.invoice_line_items.edges.length > 0) && [
                          <Grid.Row className={styles.section} key='header'>
                            <Grid.Column width={16}>
                              <Divider horizontal className={styles.heading}>
                                Line Items
                              </Divider>
                            </Grid.Column>
                          </Grid.Row>,
                          <Grid.Row
                            columns='equal'
                            className={styles.section}
                            key='content'
                          >
                            <Grid.Column>
                              <LineItems
                                node={this.props.node}
                                relay={this.props.relay}
                                canEdit={this.canEdit()}
                                totalPaid={this.props.node.total_paid_cents}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        ]}
                      {this.canEdit() &&
                        <Grid.Row columns='equal'>
                          <Grid.Column>
                            <Library
                              node={this.props.node}
                              relay={this.props.relay}
                              viewer={this.props.viewer}
                            />
                          </Grid.Column>
                        </Grid.Row>}
                      {(this.canEdit() ||
                        this.props.node.i_pplan_items.edges.length > 0) && [
                          <Grid.Row className={styles.section} key='header'>
                            <Grid.Column width={16}>
                              <Divider horizontal className={styles.heading}>
                                Payment Plan
                              </Divider>
                            </Grid.Column>
                          </Grid.Row>,
                          <Grid.Row columns='equal' key='content'>
                            <Grid.Column>
                              <PaymentPlan
                                canEdit={this.canEdit()}
                                node={this.props.node}
                                relay={this.props.relay}
                                viewer={this.props.viewer}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        ]}
                      {(this.canEdit() ||
                        this.props.node.payments.edges.length > 0) && [
                          <Grid.Row className={styles.section} key='header'>
                            <Grid.Column width={16}>
                              <Divider horizontal className={styles.heading}>
                                Payments
                              </Divider>
                            </Grid.Column>
                          </Grid.Row>,
                          <Grid.Row columns='equal' key='content'>
                            <Grid.Column>
                              <Payments
                                addPayment={this.openAddPayment}
                                canEdit={this.canEdit()}
                                node={this.props.node}
                                timeZone={(
                                  this.props.viewer &&
                                  this.props.viewer.s_time_zone) ||
                                  moment.tz.guess()}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        ]}
                      {(this.canEdit() ||
                        this.props.node.payments.edges.reduce(
                          (numRefunds, payment) =>
                            numRefunds + payment.node.refunds.edges.length, 0
                        ) > 0) && [
                          <Grid.Row className={styles.section} key='header'>
                            <Grid.Column width={16}>
                              <Divider horizontal className={styles.heading}>
                                Refunds
                              </Divider>
                            </Grid.Column>
                          </Grid.Row>,
                          <Grid.Row columns='equal' key='content'>
                            <Grid.Column>
                              <Refunds
                                canEdit={this.canEdit()}
                                node={this.props.node}
                                relay={this.props.relay}
                                timeZone={(
                                  this.props.viewer &&
                                  this.props.viewer.s_time_zone) ||
                                  moment.tz.guess()}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        ]}
                    </Grid>
                  </Segment>
                </Container>
                {this.props.params.action === 'edit' &&
                  <Pay
                    relay={this.props.relay}
                    node={this.props.node}
                    viewer={this.props.viewer}
                    onOpen={this.openAddPayment}
                    onClose={this.closeAddPayment}
                    open={this.state.addPaymentOpen}
                    window={window}
                  />}
                {this.props.params.action !== 'edit' &&
                  <div>
                    {isComputer &&
                      <div
                        className={[
                          styles.actionPromptDesktop,
                          paidInFull ? styles.actionPromptCompleted : ''
                        ].join(' ')}
                      >
                        <Container>
                          {!paidInFull &&
                            <span>This invoice is ready to pay.</span>}
                          {paidInFull &&
                            <span>
                              You have paid this invoice in full {CheckIcon}
                            </span>}
                          <Pay
                            relay={this.props.relay}
                            trigger={PayButtonDesktop}
                            node={this.props.node}
                            viewer={this.props.viewer}
                            onOpen={this.openAddPayment}
                            onClose={this.closeAddPayment}
                            open={this.state.addPaymentOpen}
                            window={window}
                          />
                        </Container>
                      </div>}
                    {isMobile &&
                      <div
                        className={[
                          styles.actionPromptMobile,
                          paidInFull ? styles.actionPromptCompleted : ''
                        ].join(' ')}
                      >
                        <Pay
                          relay={this.props.relay}
                          trigger={PayButtonMobile}
                          node={this.props.node}
                          viewer={this.props.viewer}
                          onOpen={this.openAddPayment}
                          onClose={this.closeAddPayment}
                          open={this.state.addPaymentOpen}
                          window={window}
                        />
                        {paidInFull &&
                          <p style={{ padding: '1em' }}>
                            You have paid this invoice in full {CheckIcon}
                          </p>}
                      </div>
                    }
                  </div>}
              </MobileSidebar>}
            {!this.props.node &&
              <div>
                {this.state.error &&
                  <NotFound viewer={this.props.viewer} />}
                {!this.state.error && <Loader />}
              </div>}
          </div>}
      </RootConsumer>
    );
  }
};

export default withRouter(Invoice);



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/InvoiceComponent.js